import React, { useEffect, useState } from 'react'
import { LIMIT_ALL } from '../../../../../../constants/pagination'
import { useTranslation } from 'react-i18next'
import InputTextField from '../../../../../../component/input/inputTextField';
import FilterSelect from '../../../../../../component/select/filterSelect';
import { MenuItem, Typography } from '@mui/material';

import { ClustersApi, updateCluster } from '../../../../../../api/clusters/clusters.api';
import { ButtonContained } from '../../../../../../component/mui-custom/MuiCustom';
import { useDispatch, useSelector } from 'react-redux';
import { setLoading, unsetLoading } from '../../../../../../store/slice/loading/loading.slice';
import { swalError, swalSuccess } from '../../../../../../component/notification/swal';
import { FiscalYearApi } from '../../../../../../api/fiscal-year/fiscalyear.api';

type Props = {
    fetchData: () => void;
    toggleModal: () => void;
    clusterId: number;
}

const EditClusters: React.FC<Props> = (props: Props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const idFiscalYear = useSelector((state: any) => state?.fiscalYear?.idFiscalYear);

    const [cluster, setClusters] = useState<updateCluster>({
        clustersName: "",
        clustersNo: "",
        idFiscalYear: 0,
        clustersStatus: t("STATUS.ACTIVE")
    })
    const [fiscalYear, setFiscalYear] = useState<any[]>([]);

    const handleGetFiscalYear = async () => {
        dispatch(setLoading())
        let condition: any = { limit: LIMIT_ALL }
        await FiscalYearApi.getFiscalYear(condition)
            .then(res => {
                if (res.status === 200) {
                    dispatch(unsetLoading())
                    setFiscalYear(res.data?.result?.items)
                }
            })
            .catch(error => {
                dispatch(unsetLoading())
                console.log(error)
            })
    }
    const handleGetClusters = async () => {
        dispatch(setLoading())
        await ClustersApi.getDetailClusters(props.clusterId)
            .then(res => {
                if (res.status === 200) {
                    dispatch(unsetLoading())
                    const { clustersName, clustersNo, clustersStatus, idFiscalYear } = res.data?.result
                    setClusters((prev) => ({
                        ...prev,
                        clustersName: clustersName,
                        clustersNo: clustersNo,
                        clustersStatus: clustersStatus,
                        idFiscalYear: idFiscalYear
                    }))
                }
            })
            .catch(error => {
                dispatch(unsetLoading())
                console.log(error)
            })
    }

    const handleSubmit = async (event: React.FormEvent) => {
        dispatch(setLoading())
        event.preventDefault();
        await ClustersApi.updateClusters(props.clusterId, cluster)
            .then(res => {
                if (res.status === 200) {
                    dispatch(unsetLoading())
                    swalSuccess(res.data?.description)
                }
            })
            .catch(error => {
                dispatch(unsetLoading())
                swalError(error.response?.data?.description)
                console.log(error)
            })
            .finally(() => {
                props.fetchData()
                props.toggleModal()
            })
    }

    useEffect(() => {
        handleGetFiscalYear();
        handleGetClusters();
    }, [])

    return (
        <form className='w-full' onSubmit={handleSubmit}>
            <div className='flex flex-col w-full mt-8 gap-5'>
                <span>
                    <InputTextField
                        required
                        onchange={(e: React.ChangeEvent<HTMLInputElement>) => setClusters((prev) => ({ ...prev, clustersNo: e.target.value }))}
                        value={cluster.clustersNo}
                        heading='ลำดับภารกิจ'
                    />
                </span>
                <span>
                    <InputTextField
                        required
                        onchange={(e: React.ChangeEvent<HTMLInputElement>) => setClusters((prev) => ({ ...prev, clustersName: e.target.value }))}
                        value={cluster.clustersName}
                        heading='ชื่อภารกิจ'
                    />
                </span>
                <span>
                    <FilterSelect
                        disabled
                        required
                        renderValue={() => fiscalYear.find((list: any) => list?.idFiscalYear === cluster.idFiscalYear)?.fiscalYear}
                        heading={t("ปีงบประมาณ")}
                        label={t('STATUS.LABEL')}
                        selectId="select-fiscal-year"
                        value={cluster.idFiscalYear}
                        labelId="label-fiscal-year"
                        onchange={(event: React.ChangeEvent<HTMLSelectElement>) => setClusters((prev) => ({ ...prev, idFiscalYear: Number(event.target.value) }))}
                        options={fiscalYear && fiscalYear.map((list: any) => (
                            <MenuItem disabled={list?.fiscalYearStatus === false} key={list?.idFiscalYear} value={list?.idFiscalYear}>
                                <Typography>
                                    {list?.fiscalYear}
                                </Typography>
                            </MenuItem>
                        ))}
                    />
                </span>
                <span>
                    <FilterSelect
                        required
                        heading={t("สถานะ")}
                        renderValue={() => cluster.clustersStatus === t("STATUS.ACTIVE") ?
                            <Typography className='text-light_success'> {t("STATUS.ACTIVE")}</Typography>
                            : <Typography className='text-danger'>{t('STATUS.INACTIVE')}</Typography>}
                        label={t('STATUS.LABEL')}
                        selectId="select-fiscal-year"
                        value={cluster.clustersStatus}
                        labelId="label-fiscal-year"
                        onchange={(event: React.ChangeEvent<HTMLSelectElement>) => setClusters((prev) => ({ ...prev, clustersStatus: event.target.value }))}
                        options={[
                            <MenuItem key="1" value={t("STATUS.ACTIVE")}>
                                <Typography className='text-light_success'> {t("STATUS.ACTIVE")}</Typography>
                            </MenuItem>,
                            <MenuItem key="2" value={t("STATUS.INACTIVE")}>
                                <Typography className='text-danger'>{t('STATUS.INACTIVE')}</Typography>
                            </MenuItem>
                        ]}
                    />
                </span>
                <span className='mt-3 flex justify-center items-center'>
                    <ButtonContained
                        type='submit'
                        sx={{ maxWidth: 105 }}
                    >
                        {t("BUTTON.SUBMIT")}
                    </ButtonContained>
                </span>
            </div>
        </form>
    )
}

export default EditClusters